import { Link } from 'react-router-dom';
import { ArrowLeft, Clock, User, Calendar } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function BlogPost() {
  // TODO: Später mit CMS oder dynamischen Daten ersetzen
  const post = {
    title: 'Pflegegrad beantragen in Itzehoe - Schritt für Schritt Anleitung 2025',
    excerpt: 'Alles was Sie über die Beantragung eines Pflegegrades wissen müssen - von der Antragstellung bis zur Begutachtung durch den MDK.',
    author: 'Phönix Pflege Team',
    date: '2025-01-15',
    readTime: '8 Min Lesezeit',
    category: 'Ratgeber',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200',
    content: `
      <h2>Was ist ein Pflegegrad?</h2>
      <p>Der Pflegegrad bestimmt, welche Leistungen der Pflegeversicherung Ihnen zustehen. Es gibt 5 Pflegegrade...</p>
      
      <h2>Schritt 1: Antrag stellen</h2>
      <p>Den Antrag auf Pflegegrad können Sie formlos bei Ihrer Pflegekasse stellen...</p>
      
      <h2>Schritt 2: MDK-Begutachtung</h2>
      <p>Der Medizinische Dienst der Krankenversicherung (MDK) kommt zu Ihnen nach Hause...</p>
      
      <h2>Schritt 3: Bescheid erhalten</h2>
      <p>Nach der Begutachtung erhalten Sie innerhalb von 25 Tagen den Bescheid...</p>
    `
  };

  return (
    <main id="main-content" className="pt-32 pb-20">
      <article className="container-custom">
        <div className="max-w-4xl mx-auto">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-sm text-[#64748b] mb-8" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-[#1A52D8] transition-colors">Home</Link>
            <span>/</span>
            <Link to="/ratgeber" className="hover:text-[#1A52D8] transition-colors">Ratgeber</Link>
            <span>/</span>
            <span className="text-[#1e293b]">{post.title}</span>
          </nav>

          {/* Back Button */}
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-[#1A52D8] hover:text-[#1545b8] mb-8 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Übersicht
          </Link>

          {/* Article Header */}
          <header className="mb-8">
            <div className="inline-block px-3 py-1 bg-[#1A52D8]/10 rounded-full text-[#1A52D8] text-sm font-medium mb-4">
              {post.category}
            </div>
            
            <h1 className="text-4xl md:text-5xl font-bold text-[#1e293b] mb-6 leading-tight">
              {post.title}
            </h1>
            
            <p className="text-xl text-[#64748b] mb-6 leading-relaxed">
              {post.excerpt}
            </p>

            <div className="flex flex-wrap items-center gap-6 text-sm text-[#64748b] pb-6 border-b border-[#e2e8f0]">
              <div className="flex items-center gap-2">
                <User className="w-4 h-4" />
                <span>{post.author}</span>
              </div>
              <div className="flex items-center gap-2">
                <Calendar className="w-4 h-4" />
                <time dateTime={post.date}>
                  {new Date(post.date).toLocaleDateString('de-DE', { 
                    year: 'numeric', 
                    month: 'long', 
                    day: 'numeric' 
                  })}
                </time>
              </div>
              <div className="flex items-center gap-2">
                <Clock className="w-4 h-4" />
                <span>{post.readTime}</span>
              </div>
            </div>
          </header>

          {/* Featured Image */}
          <div className="rounded-2xl overflow-hidden mb-12">
            <img 
              src={post.image}
              alt={post.title}
              className="w-full h-auto object-cover aspect-video"
              loading="eager"
            />
          </div>

          {/* Article Content */}
          <div 
            className="prose prose-lg max-w-none
              prose-headings:font-bold prose-headings:text-[#1e293b]
              prose-h2:text-2xl prose-h2:mt-12 prose-h2:mb-6 prose-h2:text-[#1A52D8]
              prose-h3:text-xl prose-h3:mt-8 prose-h3:mb-4
              prose-p:text-[#475569] prose-p:leading-relaxed prose-p:mb-6
              prose-a:text-[#1A52D8] prose-a:no-underline hover:prose-a:underline
              prose-strong:text-[#1e293b] prose-strong:font-semibold
              prose-ul:my-6 prose-ul:list-disc prose-ul:pl-6
              prose-ol:my-6 prose-ol:list-decimal prose-ol:pl-6
              prose-li:text-[#475569] prose-li:mb-2"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />

          {/* CTA Box */}
          <div className="mt-16 p-8 bg-gradient-to-br from-[#f8fafb] to-[#e8f8f8] rounded-2xl border border-[#e2e8f0]">
            <h3 className="text-2xl font-bold text-[#1e293b] mb-4">
              Brauchen Sie Hilfe bei der Antragstellung?
            </h3>
            <p className="text-[#64748b] mb-6">
              Unser Team unterstützt Sie gerne kostenlos bei der Beantragung des Pflegegrades 
              und beantwortet alle Ihre Fragen rund um die ambulante Pflege in Itzehoe.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="tel:+4915146173685">
                <Button className="bg-[#1A52D8] text-white hover:bg-[#1545b8]">
                  Jetzt Anrufen
                </Button>
              </a>
              <Link to="/kontakt">
                <Button className="bg-white text-[#1A52D8] border-2 border-[#1A52D8]/20 hover:border-[#1A52D8]">
                  Kontakt aufnehmen
                </Button>
              </Link>
            </div>
          </div>

          {/* Related Articles (TODO) */}
          <div className="mt-16">
            <h3 className="text-2xl font-bold text-[#1e293b] mb-8">Weitere Artikel</h3>
            <div className="grid md:grid-cols-2 gap-6">
              {/* TODO: Dynamisch aus CMS laden */}
              <p className="text-[#64748b]">Weitere Artikel folgen bald...</p>
            </div>
          </div>
        </div>
      </article>
    </main>
  );
}
